/* Limavia — Extracto de Ajo landing behaviours.
   Loaded from the main product section so it can never be disabled by hiding
   an optional section. Everything is namespaced and defensive: a missing
   element must never throw and must never block the native product form. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ----------------------------------------------------------------
     Countdown (promo bar)
     ---------------------------------------------------------------- */
  function initCountdown(el) {
    if (el.dataset.cplAjoInit === '1') return;
    el.dataset.cplAjoInit = '1';

    var pad = function (n) { return String(n).padStart(2, '0'); };
    var nodes = {
      d: el.querySelector('[data-cpl-ajo-d]'),
      h: el.querySelector('[data-cpl-ajo-h]'),
      m: el.querySelector('[data-cpl-ajo-m]'),
      s: el.querySelector('[data-cpl-ajo-s]')
    };

    var fixed = el.dataset.cplAjoEnd ? Date.parse(el.dataset.cplAjoEnd) : NaN;
    var cycleHours = parseFloat(el.dataset.cplAjoHours || '60');
    if (!(cycleHours > 0)) cycleHours = 60;
    var cycleMs = cycleHours * 3600000;

    function endTime() {
      if (!isNaN(fixed)) return fixed;
      // Evergreen: a repeating cycle anchored to the epoch, so the timer is
      // always counting down and identical for everyone at a given moment.
      var now = Date.now();
      return Math.ceil((now + 1) / cycleMs) * cycleMs;
    }

    function tick() {
      var diff = Math.max(0, endTime() - Date.now());
      var d = Math.floor(diff / 86400000); diff -= d * 86400000;
      var h = Math.floor(diff / 3600000); diff -= h * 3600000;
      var m = Math.floor(diff / 60000); diff -= m * 60000;
      var s = Math.floor(diff / 1000);
      if (nodes.d) nodes.d.textContent = pad(d);
      if (nodes.h) nodes.h.textContent = pad(h);
      if (nodes.m) nodes.m.textContent = pad(m);
      if (nodes.s) nodes.s.textContent = pad(s);
    }

    tick();
    var t = setInterval(tick, 1000);
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(el)) clearInterval(t);
    });
  }

  /* ----------------------------------------------------------------
     Gallery: arrows + swipe + thumbnails in sync
     ---------------------------------------------------------------- */
  function initGallery(root) {
    if (root.dataset.cplAjoInit === '1') return;
    root.dataset.cplAjoInit = '1';

    var track = root.querySelector('[data-cpl-ajo-gallery-track]');
    if (!track) return;
    var slides = $$('[data-cpl-ajo-slide]', track);
    var thumbs = $$('[data-cpl-ajo-thumb]', root);
    var prev = root.querySelector('[data-cpl-ajo-prev]');
    var next = root.querySelector('[data-cpl-ajo-next]');
    if (slides.length < 2) return;

    var active = 0;

    function setActive(i) {
      if (i === active) return;
      active = i;
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      var live = root.querySelector('[data-cpl-ajo-gallery-status]');
      if (live) live.textContent = (i + 1) + ' / ' + slides.length;
    }

    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      setActive(idx);
    }

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (!track.clientWidth) return;
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(active - 1); });
    if (next) next.addEventListener('click', function () { goTo(active + 1); });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    // Keyboard support on the stage.
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
    });

    setActive(0);
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === 0 ? 'true' : 'false'); });
  }

  /* ----------------------------------------------------------------
     Accordions
     ---------------------------------------------------------------- */
  function initAccordion(root) {
    if (root.dataset.cplAjoInit === '1') return;
    root.dataset.cplAjoInit = '1';

    var single = root.dataset.cplAjoSingle !== 'false';
    var items = $$('[data-cpl-ajo-acc-item]', root);

    items.forEach(function (item) {
      var btn = item.querySelector('[data-cpl-ajo-acc-btn]');
      var panel = item.querySelector('[data-cpl-ajo-acc-panel]');
      var sign = item.querySelector('[data-cpl-ajo-acc-sign]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (single && !isOpen) {
          items.forEach(function (other) {
            if (other === item) return;
            var ob = other.querySelector('[data-cpl-ajo-acc-btn]');
            var op = other.querySelector('[data-cpl-ajo-acc-panel]');
            var os = other.querySelector('[data-cpl-ajo-acc-sign]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.hidden = true;
            if (os) os.textContent = '+';
          });
        }
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
        if (sign) sign.textContent = isOpen ? '+' : '–';
      });
    });
  }

  /* ----------------------------------------------------------------
     Horizontal carousels (reviews / videos)
     ---------------------------------------------------------------- */
  function initCarousel(root) {
    if (root.dataset.cplAjoInit === '1') return;
    root.dataset.cplAjoInit = '1';

    var track = root.querySelector('[data-cpl-ajo-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-cpl-ajo-prev]');
    var next = root.querySelector('[data-cpl-ajo-next]');

    function nudge(dir) {
      track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.9), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
  }

  /* ----------------------------------------------------------------
     Video cards: buffer with the page, play on tap
     ---------------------------------------------------------------- */
  function initVideos(root) {
    if (root.dataset.cplAjoInit === '1') return;
    root.dataset.cplAjoInit = '1';

    $$('[data-cpl-ajo-video-card]', root).forEach(function (card) {
      var video = card.querySelector('video');
      var play = card.querySelector('[data-cpl-ajo-play]');
      if (!video) return;

      // Buffer immediately, alongside the rest of the page.
      try {
        video.preload = 'auto';
        video.load();
      } catch (e) { /* no-op */ }

      if (!play) return;
      play.addEventListener('click', function () {
        $$('[data-cpl-ajo-video-card] video', document).forEach(function (v) {
          if (v !== video) { v.pause(); }
        });
        $$('[data-cpl-ajo-video-card]', document).forEach(function (c) {
          if (c !== card) c.classList.remove('is-playing');
        });
        card.classList.add('is-playing');
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () { card.classList.remove('is-playing'); });
      });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    });
  }

  /* ----------------------------------------------------------------
     Header: nav drawer
     ---------------------------------------------------------------- */
  function initHeader(root) {
    if (root.dataset.cplAjoInit === '1') return;
    root.dataset.cplAjoInit = '1';

    var burger = root.querySelector('[data-cpl-ajo-burger]');
    var drawer = root.querySelector('[data-cpl-ajo-nav-drawer]');
    if (!burger || !drawer) return;
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
      drawer.hidden = open;
    });
  }

  /* ----------------------------------------------------------------
     Sticky bar
     - hidden on load
     - appears once the buy box has scrolled away (or ~50% of the page)
     - mirrors the main price node, never recalculates it
     - scrolls to the buy area; it NEVER adds to cart
     ---------------------------------------------------------------- */
  function initSticky(bar) {
    if (bar.dataset.cplAjoInit === '1') return;
    bar.dataset.cplAjoInit = '1';

    var anchorSel = bar.dataset.cplAjoAnchor || '[data-cpl-ajo-buy-anchor]';
    var anchor = document.querySelector(anchorSel);
    var btn = bar.querySelector('[data-cpl-ajo-sticky-btn]');

    // --- price mirroring -------------------------------------------------
    var srcNow = document.querySelector('[data-cpl-ajo-price-now]');
    var srcWas = document.querySelector('[data-cpl-ajo-price-was]');
    var dstNow = bar.querySelector('[data-cpl-ajo-sticky-now]');
    var dstWas = bar.querySelector('[data-cpl-ajo-sticky-was]');
    var dstPrices = bar.querySelector('[data-cpl-ajo-sticky-prices]');

    function mirror() {
      var nowText = srcNow ? srcNow.textContent.trim() : '';
      var wasText = srcWas ? srcWas.textContent.trim() : '';
      if (dstNow) dstNow.textContent = nowText;
      if (dstWas) {
        dstWas.textContent = wasText;
        dstWas.hidden = wasText === '';
      }
      // With prices switched off (bundles own them) there is nothing to mirror:
      // collapse the line instead of leaving an empty gap.
      if (dstPrices) dstPrices.hidden = nowText === '' && wasText === '';
    }
    mirror();

    if (window.MutationObserver) {
      var mo = new MutationObserver(mirror);
      var opts = { childList: true, characterData: true, subtree: true };
      if (srcNow) mo.observe(srcNow, opts);
      if (srcWas) mo.observe(srcWas, opts);
      // The bundle app can replace the whole buy area; watch it too.
      var buyArea = document.querySelector('[data-cpl-ajo-buy-anchor]');
      if (buyArea) mo.observe(buyArea, opts);
    }
    document.addEventListener('variant:change', mirror);
    document.addEventListener('kaching-bundles:change', mirror);

    // --- visibility ------------------------------------------------------
    function shouldShow() {
      var halfway = (window.scrollY || window.pageYOffset) >
        Math.max(400, (document.documentElement.scrollHeight - window.innerHeight) * 0.5);
      if (!anchor) return halfway;
      var r = anchor.getBoundingClientRect();
      return r.bottom < 0 || halfway;
    }

    var shown = false;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var next = shouldShow();
        if (next === shown) return;
        shown = next;
        bar.classList.toggle('is-visible', shown);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    // --- action: scroll to the buy area, never add to cart ---------------
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = anchor || document.querySelector('[data-cpl-ajo-buy-anchor]');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var submit = target.querySelector('.product-form__submit');
        if (submit) {
          setTimeout(function () {
            try { submit.focus({ preventScroll: true }); } catch (err) { /* no-op */ }
          }, 500);
        }
      });
    }
  }

  /* ---------------------------------------------------------------- */
  function boot(scope) {
    var root = scope || document;
    $$('[data-cpl-ajo-countdown]', root).forEach(initCountdown);
    $$('[data-cpl-ajo-gallery]', root).forEach(initGallery);
    $$('[data-cpl-ajo-accordion]', root).forEach(initAccordion);
    $$('[data-cpl-ajo-carousel]', root).forEach(initCarousel);
    $$('[data-cpl-ajo-videos]', root).forEach(initVideos);
    $$('[data-cpl-ajo-header]', root).forEach(initHeader);
    $$('[data-cpl-ajo-sticky]', root).forEach(initSticky);
  }

  ready(function () { boot(document); });

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target) boot(e.target);
  });
})();
